import { PinnedLayoutCssFeature } from './pinnedLayout.types'
import { pinnedLayoutDomApplier } from './pinnedLayoutDomApplier'
import { pinnedStyle } from './pinnedLayoutCompNode'
import { autoHeightWrapper, autoHeightWrapperViewer } from '../autoHeightWrapper/autoHeightWrapperCompNode'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const editorPinnedLayoutCssFeature: PinnedLayoutCssFeature = {
	featureName: 'pinnedLayout',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { pinnedStyle },
	intermediateNodes: { autoHeightWrapper },
	dataMaps: ['component_properties'],
	domApplier: pinnedLayoutDomApplier,
}

export const pinnedLayoutCssFeature: PinnedLayoutCssFeature = {
	...editorPinnedLayoutCssFeature,
	intermediateNodes: { autoHeightWrapper: autoHeightWrapperViewer },
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(pinnedLayoutCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorPinnedLayoutCssFeature)
}
